export class FilterViewModel {
    name: string;
    value: string;
    geography: string;

    constructor() {
        this.name = '';
        this.value = '';
        this.geography='';
    }
}
export class FilterViewModelForOwner{
    name: string;
    value: string;
    externalUserId: string;

    constructor() {
        this.name = '';
        this.value = '';
        this.externalUserId='';
    }
}
